/**
 * Created by sxp23 on 1/18/2018.
 */
import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
//import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { CommonService } from "../common.service";
import { SharedService } from "../shared.service";
/*import { NgbdModalContent } from './modal.component'*/

@Component({
  selector: "water-esri-maps",
  templateUrl: "./water-maps.component.html",
  styleUrls: ["./water-maps.component.css"],
})
export class WaterMapsComponent implements OnInit, AfterViewInit {
  selectedLayers4: string[]; // = ["decTX"];//["dohPWS", "decBM", "decPWL", "decSPDE"];
  selectedLayers3: string[]; // = ["decBM"];
  selectedLayers1: string[];
  selectedLayers2: string[];

  //homeLat;homeLng;homeAdr;
  location: string;
  searchText;
  results;
  updateLoc: boolean = false;
  mobile = false;
  iPad = false;

  @ViewChild("contentPWL") contentPWL: ElementRef;

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private modalService: NgbModal
  ) {
    //this.modalService.open(NgbdModalContent,{ size: 'lg', backdrop: 'static' });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalService.open(this.contentPWL, {
        size: "lg",
        windowClass: "modal-adaptive",
      });
    }, 200);
  }

  ngOnInit() {
    //console.log("at WaterMapsComponent Location:",this.sharedService.getHomeAddress())
    if (window.screen.width < 768) {
      // 768px portrait
      this.mobile = true;
    } else if (window.screen.width < 1000) {
      this.iPad = true;
    }
    if (this.sharedService.getHomeAddress()) {
      var homeLoc = JSON.parse(this.sharedService.getHomeAddress());
      this.location = homeLoc.homeAddress;
    }

    /*if (this.sharedService.getFlowFlag() === "DOH"){
      this.selectedLayers1 = ["dohPWS"];//["dohPWS", "decBM", "decPWL", "decSPDE"];
    }
    else{*/
    //this.selectedLayers4 = ["decTX"];//["dohPWS", "decBM", "decPWL", "decSPDE"];
    //this.selectedLayers3= ["decBM"];
    this.selectedLayers2 = ["decPWL"];
    //this.modalService.open('<ng-template let-c="close" let-d="dismiss"><div class="modal-body"><p><span ngbAutoFocus></span>This map represents NYSDEC’s waterbody inventory/priority waterbodies list. This is an inventory of NYS waters and assesses the overall water quality, causes and sources of water quality impairments and the status of restoration, protection, or other water quality activities and efforts. NY Waters are divided into segments, each segment has a factsheet outlining the most recent assessment of the waterbody. <br/><br/>For more information about the waterbody inventory and how the information is collected and used visit: <a href="https://www.dec.ny.gov/environmental-protection/water" target="_blank">https://www.dec.ny.gov/environmental-protection/water</a>.  <br/><br/>Impaired waters are waterbodies that are not supporting designated uses and may require development of a watershed plan to restore the designated uses. For more information about impaired waters and how they are determined visit: <a href="https://www.dec.ny.gov/chemical/31290.html" target="_blank">https://www.dec.ny.gov/chemical/31290.html</a>.</p> </div><div class="modal-footer center">  <button type="button" class="btn btn-primary center" (click)="c(\'Close click\')">Close</button></div></ng-template>', { size: 'lg', windowClass: 'modal-adaptive' });
    //}
    //this.modalService.open(NgbdModalContent,{ size: 'lg', backdrop: 'static' });
  }

  open(content) {
    this.modalService.open(content, {
      size: "lg",
      windowClass: "modal-adaptive",
    });
  }
}
